// extracted by mini-css-extract-plugin
module.exports = {"loadingGif":"Loading_loadingGif__2-CzD"};